import {
  LEAD_ID,
  LEAD_IS_REQUESTING,
  LEAD_REQUESTING_END
} from "../actions/types";

const initialState = {
  idLead: null,
  requestingLead: false
};

export default (state = initialState, action) => {
  var newState;
  switch (action.type) {
    case LEAD_ID:
      newState = { ...state };
      newState.idLead = action.data;
    return newState;
    case LEAD_IS_REQUESTING:
      newState = { ...state };
      newState.requestingLead = true;
    return newState;
    case LEAD_REQUESTING_END:
      newState = { ...state };
      newState.requestingLead = false;
    return newState;
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/lead.js